import { render, staticRenderFns } from "./Multiselectfaq.vue?vue&type=template&id=08f151e2&"
import script from "./Multiselectfaq.vue?vue&type=script&lang=js&"
export * from "./Multiselectfaq.vue?vue&type=script&lang=js&"
import style0 from "./Multiselectfaq.vue?vue&type=style&index=0&lang=scss&scope=app%2Fassets%2Fstylesheets%2Fcomponents%2Ffaqs&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports